import { defaultInternalOrdersFilters, IPillFilter, useStore } from "../store";
import { IDateRange } from "../contracts";

export interface IInternalOrdersRedirectionFilters {
  orderCreationRange?: IDateRange;
  status?: number;
}

export const useInternalOrdersFiltersActions = () => {
  const [_, setState] = useStore();

  const setCustomSelectionFilter = ({
    filterAccessor,
    newValues
  }: {
    filterAccessor: string;
    newValues: IPillFilter[];
  }) => {
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        [filterAccessor]: newValues
      }
    }));
  };

  const setInternalLocationStatusFilter = (newValue: number) => {
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        locationStatuses: (old.internalOrdersCommonFilters.locationStatuses || []).some(
          status => status === newValue
        )
          ? (old.internalOrdersCommonFilters.locationStatuses || []).filter(s => s !== newValue)
          : [...(old.internalOrdersCommonFilters.locationStatuses || []), newValue]
      }
    }));
  };

  const setInternalDeliveryStatusFilter = (newValue: number) => {
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        deliveryStatuses: (old.internalOrdersCommonFilters.deliveryStatuses || []).some(
          status => status === newValue
        )
          ? (old.internalOrdersCommonFilters.deliveryStatuses || []).filter(s => s !== newValue)
          : [...(old.internalOrdersCommonFilters.deliveryStatuses || []), newValue]
      }
    }));
  };

  const setInternalFilter = (accessor: string, newValue: IDateRange | number[] | IPillFilter[]) => {
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        [accessor]: newValue
      }
    }));
  };

  const clearInternalFilter = (accessor: string) => {
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        [accessor]: defaultInternalOrdersFilters[accessor]
      }
    }));
  };

  const setInternalOrdersRedirectionFilters = (filters: IInternalOrdersRedirectionFilters) => {
    const { orderCreationRange, status } = filters;
    setState(old => ({
      ...old,
      internalOrdersCommonFilters: {
        ...old.internalOrdersCommonFilters,
        orderCreationRange,
        deliveryStatuses: status === undefined ? undefined : [status]
      }
    }));
  };

  return {
    setCustomSelectionFilter,
    setInternalLocationStatusFilter,
    setInternalDeliveryStatusFilter,
    setInternalFilter,
    setInternalOrdersRedirectionFilters,
    clearInternalFilter
  };
};
